import React, { useState } from 'react';

/* MobX */
// import { observer } from 'mobx-react-lite';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const UpdateUser = props => {
  const classes = useStyles();
  const [username, setUsername] = useState("");

  return (
    <div className={classes.paper}>
      <form autoComplete="off" noValidate >
        <Grid container spacing={2}>
          <Grid item xs={12} align="center">
            <TextField name="searchUser" label="Search User" variant="outlined" required fullWidth value={username} onChange={(e) => setUsername(e.target.value)} />
          </Grid>
          <Grid item xs={12} align="center">
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>Submit</Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
};

export default UpdateUser;